module.exports = __webpack_public_path__ + "static/media/TributePage.785f13a8.jpg";